import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RouterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"router"}/>
}
